// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1hRFt","text":"SelectPayment_text__1L0MY","title":"SelectPayment_title__Fkt_s","btn":"SelectPayment_btn__3gQgX"};